import { FC } from 'react';

import {
    ActionBar,
    Banner,
    BottomSheet,
    Button,
    HSpacingContainer,
    Modal,
    NavBar,
    Text,
    VSpacing,
} from '@hh.ru/magritte-ui';

import { formatToReactComponent } from 'bloko/common/trl';

import useTrls from 'hooks/translation/useTrls';

import { MagritteModalHeader } from 'components/common/MagritteModalHeader/MagritteModalHeader';

import { setWrongRequisitesModalOpen } from 'store/models/requisites';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'WrongRequisitesModal.title',
    description: {
        text: 'WrongRequisitesModal.description.text',
    },
    information: {
        text: 'WrongRequisitesModal.description.information.text',
        linkHref: 'WrongRequisitesModal.description.information.link.href',
        linkText: 'WrongRequisitesModal.description.information.link.text',
    },
    close: 'WrongRequisitesModal.close',
    mailToSupport: 'WrongRequisitesModal.mailToSupport',
};

const WrongRequisitesModal: FC = () => {
    const isWrongRequisitesModalOpen = useSelector((state) => state.requisites.isWrongRequisitesModalOpen);
    const clickmeEmail = useSelector((state) => state.clickme.email);
    const currentAccountId = useSelector((state) => state.user.user?.currentAccount.id);

    const dispatch = useDispatch();
    const trl = useTrls();

    const hrefMailTo = `mailto:${clickmeEmail}?subject=${trl(TrlKeys.title)} ${
        currentAccountId ? `(accountId: ${currentAccountId})` : ''
    }`;

    const onClose = () => dispatch(setWrongRequisitesModalOpen(false));

    const footer = (
        <ActionBar
            primaryActions={
                <Button Element="a" mode="primary" style="accent" href={hrefMailTo}>
                    {trl(TrlKeys.mailToSupport)}
                </Button>
            }
            secondaryActions={
                <Button mode="secondary" style="accent" onClick={onClose}>
                    {trl(TrlKeys.close)}
                </Button>
            }
        />
    );
    const titleDescription = formatToReactComponent(trl(TrlKeys.description.text), {
        '[0]': <a href={hrefMailTo}>{clickmeEmail}</a>,
    });
    const content = (
        <Banner
            showClose={false}
            style="warning-secondary"
            content={
                <Text typography="paragraph-2-regular">
                    {formatToReactComponent(trl(TrlKeys.information.text), {
                        '[0]': (
                            <a href={trl(TrlKeys.information.linkHref)} target="_blank" rel="noreferrer">
                                {trl(TrlKeys.information.linkText)}
                            </a>
                        ),
                    })}
                </Text>
            }
        />
    );
    return (
        <>
            <Modal
                visible={isWrongRequisitesModalOpen}
                header={<MagritteModalHeader title={trl(TrlKeys.title)} subtitle={titleDescription} size="small" />}
                size="medium"
                onClose={onClose}
                footer={footer}
            >
                {content}
            </Modal>
            <BottomSheet
                height="content"
                visible={isWrongRequisitesModalOpen}
                onClose={onClose}
                header={
                    <HSpacingContainer default={12}>
                        <NavBar>
                            <NavBar.Pane>
                                <Text typography="title-4-semibold">{trl(TrlKeys.title)}</Text>
                                <VSpacing default={8} />
                                <Text typography="paragraph-1-regular">{titleDescription}</Text>
                            </NavBar.Pane>
                        </NavBar>
                    </HSpacingContainer>
                }
                footer={footer}
            >
                {content}
            </BottomSheet>
        </>
    );
};

export default WrongRequisitesModal;
